const aspectRatio = {
    name: "aspect-ratio",
    path: "/aspect-ratio",
    title: "aspect-ratio",
    description: "Utilities for controlling the aspect ratio of an element.",
    value: {
        "aspect-ratio": {
            "aspect-<ratio>": "<ratio>",
            "aspect-square": "1 / 1",
            "aspect-video": "16 / 9",
            "aspect-portrait": "9 / 16",
            "aspect-auto": "auto",
        }
    },
    exampleData: [
        {
            "title": "aspect-<ratio>",
            "description": "utilities like aspect-3/2 to give an element a specific aspect ratio.",
            "moreDescription": "",
            "parentClass": "max-w-lg",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": ""
                    }
                ],
                "className": "aspect-3/2 object-cover w-full rounded-lg overflow-hidden",
                "code": "<img class=\"aspect-3/2 object-cover ...\" src=\"/img/image.jpg\" />"
            }
        },
        {
            "title": "aspect-square",
            "description": "utilities like aspect-1/1 to give an element a specific aspect ratio.",
            "moreDescription": "",
            "parentClass": "max-w-lg",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": ""
                    }
                ],
                "className": "aspect-square object-cover w-full rounded-lg overflow-hidden",
                "code": "<img class=\"aspect-square object-cover ...\" src=\"/img/image.jpg\" />"
            }
        },
        {
            "title": "aspect-video",
            "description": "utility to give a video element a 16/9 aspect ratio.",
            "moreDescription": "",
            "parentClass": "max-w-lg",
            "example": {
                "element": "iframe",
                "src": [
                    {
                        "src": "https://www.youtube.com/embed/dQw4w9WgXcQ",
                        "className": ""
                    }
                ],
                "className": "aspect-video object-cover w-full rounded-lg overflow-hidden",
                "code": "<iframe class=\"aspect-video ...\" src=\"https://www.youtube.com/embed/dQw4w9WgXcQ\" />"
            }
        }
    ]
};

export default aspectRatio;